export enum COOKIE_KEY {
  ACCESS_TOKEN = "cms_access_token",
  REFRESH_TOKEN = "cms_refresh_token",
  LAST_LOGIN = "cms_last_login",
}

export const COOKIE_LIST = [COOKIE_KEY.ACCESS_TOKEN, COOKIE_KEY.REFRESH_TOKEN, COOKIE_KEY.LAST_LOGIN];
